import React from 'react';
import './WhyChoose.css';

function WhyChoose() {
    const reasons = [
        " Expert-Led Care: Certified physiotherapists with advanced training, committed to evidence-based treatment.",
        " NRI-Centric Approach: Dedicated online care for Indians abroad, with flexible scheduling and culturally attuned therapy.",
        " Global Access, Local Expertise: Virtual consultations for NRIs worldwide, blending India’s clinical excellence with seamless digital convenience",
        " Your Safety, Your Space: Receive treatment securely at home, work, or online—no compromises on comfort.",
        " Flexible Scheduling: Book 24/7 with weekend and evening slots designed around your routine.",
        " Tech-Driven: Real-time virtual sessions + AI-driven progress tracking"
    ];

    return (
        <section className="why-choose-section">
            <h2>Why Choose RapidPhysio?</h2>
            <ul className="reasons-list">
                {reasons.map((reason, index) => (
                    <li key={index}>{reason}</li>
                ))}
            </ul>
        </section>
    );
}

export default WhyChoose;
